import { Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import AutoScrollContainer from '../../utils/AutoScrollContainer'
import DF from './DataNumberField'
import EntryItem from './RampupEntryItem'
import { useAppSelector } from './RunReduxHooks'
import { selectIsDevice15 } from './sliceRunProcHeader'
import UIRampupBGAOnPASampleSelector from './UIRampupBGAOnPASampleSelector'
import UIRampupVentParameters32C from './UIRampupVentParameters32C'
import UIRampupVentParameters32CDraeger from './UIRampupVentParameters32CDraeger'

export default function UIRampupStep0t32C() {
    const { step } = useParams()
    const isDevice15 = useAppSelector(selectIsDevice15)

    return (
        <AutoScrollContainer bottomOffset={70}>
            <EntryItem>
                <Typography color='warning.main' variant='h5'>Set ventilation parameters</Typography>
                {isDevice15
                    ? <UIRampupVentParameters32CDraeger />
                    : <UIRampupVentParameters32C />
                }
            </EntryItem>
            <EntryItem>
                <Typography variant='h5'>Disengage airway clamp</Typography>
            </EntryItem>
            <EntryItem>
                <Typography variant='h5'>Press "Start Ventilation" on the Ventilator</Typography>
            </EntryItem>
            <EntryItem>
                <Typography variant='h5'>Start the EVLP gas flow</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <DF fullWidth field='EVLPGasFlow' step={step} />
                    </Grid>
                </Grid>
            </EntryItem>
            <UIRampupBGAOnPASampleSelector />
        </AutoScrollContainer>
    )
}